import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id EC642A5A-34A2-4E29-85F1-60ACAA546FB1
 * name cellphone-remove
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-remove.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const CellphoneRemoveIcon = createSvgIcon(<><path d="M22.54 16.88L21.12 15.47L19 17.59L16.88 15.47L15.47 16.88L17.59 19L15.47 21.12L16.88 22.54L19 20.41L21.12 22.54L22.54 21.12L20.41 19L22.54 16.88M14.54 23H7C5.9 23 5 22.11 5 21V3C5 1.89 5.89 1 7 1H17C18.1 1 19 1.89 19 3V13C18.3 13 17.63 13.13 17 13.35V5H7V19H13C13 20.54 13.58 21.94 14.54 23Z" /></>, 'CellphoneRemoveIcon');
export default CellphoneRemoveIcon